import React from "react";
import { Microsoft } from "@mui/icons-material";

export default function SignIn() {
  const API_URL = "/api/sign-in";

  return (
    <div className="sign-in">
      <div className="sign-in-title">
        <h1 className="cgi-name">CGI</h1>
        <h1>ITS JumpStart</h1>
      </div>

      <a href={API_URL} className="sign-in-btn">
        <Microsoft fontSize="small" color="#fff" />
        Sign in using Microsoft
      </a>
    </div>
  );
}
